import { render, staticRenderFns } from "./gatorz-youtube.vue?vue&type=template&id=5fcf84c6&scoped=true&"
import script from "./gatorz-youtube.vue?vue&type=script&lang=js&"
export * from "./gatorz-youtube.vue?vue&type=script&lang=js&"
import style0 from "./gatorz-youtube.vue?vue&type=style&index=0&id=5fcf84c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf84c6",
  null
  
)

export default component.exports